import React from 'react'
import { Button } from 'antd'

import VolumeSlider from '../_components/VolumeSlider'
import CollapseCorner from '../_components/CollapseCorner'
import Duration from '../_components/Duration'
import { useGlobalPlayerStateIcon } from '../_hooks/states'
import { useAudioTrack } from '../_hooks/audioTrack'

import { CssIcon } from '@/components/CssIcon'
import Waveform from '@/components/Waveform'
import MusicProfile from '@/components/MusicProfile'
import MusicOptions from '@/pages/tad.ai/_components/MusicItem/_components/MusicOptions'
import { formatAudioTime } from '@/helpers/music'
import { useInWhichPage } from '@/hooks/useInWhichPage'


import { useGlobalAudioPlayer } from '@/hooks/audio/store';
import { cls } from 'tagged-classnames-free';
export interface AudioPlayerFullProps {}

const AudioPlayerFull: React.FC<AudioPlayerFullProps> = (props) => {
  const globalPlayer = useGlobalAudioPlayer()
  useAudioTrack()

  const { stateIcon } = useGlobalPlayerStateIcon()
  const { inDetailPage } = useInWhichPage()

  return (
    <div
      className={cls`
        bg-f-bg-container border-f-border-active relative border-t
      `}
    >
      <CollapseCorner
        collapsed={globalPlayer.collapsed}
        onChange={() => {
          globalPlayer.toggleCollapsed()
        }}
      />
      <div
        className={cls`
          bg-f-other-1 flex items-center
          justify-between ${globalPlayer.collapsed ? 'h-0' : 'h-[88px]'}
          z-10 gap-1
          overflow-hidden px-4 transition-[height]
          md:px-6
        `}
      >
        <div className='flex min-w-0 items-center gap-3 md:gap-5'>
          <MusicProfile
            data={globalPlayer.meta}
            cover={{
              src: globalPlayer.meta?.cover,
              size: 24,
              imageClassName: cls`rounded-full md:!size-14 md:rounded-lg`,
            }}
            showTypes={['userInfo']}
            inGlobalPlayer
          />
        </div>
        <div className='flex w-[45%] min-w-[150px] max-w-[460px] flex-col items-center justify-center gap-y-1'>
          <div
            className={cls` relative  items-center ${inDetailPage ? 'w-full text-center' : 'flex w-full justify-around md:w-3/5'}`}
          >
            {!inDetailPage && (
              <Button type='text' className='h-6 p-0'>
                <CssIcon
                  className='i-cus--tad-previous-song text-f-text size-6'
                  onClick={(event) => {
                    event.stopPropagation()
                    globalPlayer.playPrev()
                  }}
                />
              </Button>
            )}
            <Button type='text' className={cls`h-6 px-1`}>
              <CssIcon
                className={cls`${stateIcon} text-f-text size-6`}
                onClick={(event) => {
                  event.stopPropagation()
                  globalPlayer.toggle()
                }}
              />
            </Button>
            {!inDetailPage && (
              <Button type='text' className='h-6 p-0'>
                <CssIcon
                  className='i-cus--tad-next-song text-f-text size-6'
                  onClick={(event) => {
                    event.stopPropagation()
                    globalPlayer.playNext()
                  }}
                />
              </Button>
            )}
            <VolumeSlider
              volume={globalPlayer.volume}
              onChange={(volume) => {
                globalPlayer.volumeUpdate(volume)
              }}
              className={cls`${inDetailPage ? '!absolute right-1' : ''}`}
            />
            {/* <Tooltip overlay={'Repeat one'}>
              <Button type='text' className='h-7 px-1'>
                <CssIcon
                  className={cls`i-cus--tad-single-song-loop size-5 ${
                    globalPlayer.loop === 'off'
                      ? 'text-f-text-quaternary'
                      : 'text-f-text-tertiary'
                  }`}
                  onClick={(event) => {
                    event.stopPropagation()
                    globalPlayer.loopToggle()
                  }}
                />
              </Button>
            </Tooltip> */}
          </div>
          <div
            className={`text-f-text-tertiary flex w-full items-center justify-end gap-1 text-[12px]`}
          >
            <span>{formatAudioTime(globalPlayer.currentTimeInSeconds)}</span>
            <Waveform
              className={cls`flex-1`}
              audio={{
                url: globalPlayer.meta?.src,
                duration: globalPlayer.meta?.duration || 0,
                height: 4,
              }}
              showWave={false}
              onPlayAudio={(playStart) => {
                if (globalPlayer.meta) {
                  globalPlayer.play(globalPlayer.meta, playStart)
                }
              }}
            />
            <Duration
              className={cls`text-[12px]`}
              value={
                (globalPlayer.meta?.duration || 0) -
                globalPlayer.currentTimeInSeconds
              }
              negative
            />
          </div>
        </div>
        <MusicOptions
          data={globalPlayer.meta!}
          className='shrink-0'
          expand={[
            { key: 'liked', iconOnly: true },
            // { key: 'share', iconOnly: true },
          ]}
        />
      </div>
    </div>
  )
}

export default AudioPlayerFull
